// extracted by mini-css-extract-plugin
export var footer = "FooterTemplate-module--footer--6414a";
export var footerContainer = "FooterTemplate-module--footerContainer--fbb05";
export var forumStandaardisatieIcon = "FooterTemplate-module--forumStandaardisatieIcon--d981e";
export var heading = "FooterTemplate-module--heading--8621e";
export var list = "FooterTemplate-module--list--0df1a";
export var logosContainer = "FooterTemplate-module--logosContainer--31575";
export var navigation = "FooterTemplate-module--navigation--e4172";